// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"259":"1f93e221","496":"38d95697"}[chunkId] + ".chunk.js";
};